export default __webpack_public_path__ + "fd898a5c5c6c01acc2cedaf5a80a2cb1.png";